import { Icon } from '@mdi/react';
import { Tooltip } from '@mui/material';
import React from 'react';
import { TooltipTransitionComponent } from '../base';
import * as S from './provider-action-button.styles';

interface IProviderActionButtonProps {
    icon: string;
    tooltipPrefix: string;
    count?: number;
    disabled?: boolean;
    onClick: () => void;
}

export const ProviderActionButton: React.FunctionComponent<IProviderActionButtonProps> = (
    props: IProviderActionButtonProps,
): React.ReactElement => {
    const { icon, tooltipPrefix, count, disabled, onClick } = props;
    const message = count ? `Move ${count} messages ${tooltipPrefix}` : `Move ${tooltipPrefix}`;
    return (
        <Tooltip title={<span>{message}</span>} TransitionComponent={TooltipTransitionComponent}>
            <div>
                <S.ProviderActionButton variant="outlined" onClick={onClick} disabled={disabled}>
                    <Icon path={icon} size={1} />
                </S.ProviderActionButton>
            </div>
        </Tooltip>
    );
};

